import InfoIcon from "@mui/icons-material/Info";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import useTheme from "@mui/material/styles/useTheme";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalType, useModal } from "@/components/ModalProvider";

export function IgnitionCell(props: GridRenderCellParams) {
  let bgColor = "disabled";
  const theme = useTheme();
  switch (props.value) {
    case 0:
      bgColor = theme.palette.grey[400];
      break;
    case 1:
      bgColor = theme.palette.success.main;
      break;
    default:
      bgColor = "transparent";
  }

  const { t } = useTranslation();
  const translations = [t("off"), t("on")];
  const [isHovered, setIsHovered] = useState(false);
  const { openModal } = useModal();

  return (
    <Tooltip
      style={{ height: "100%" }}
      title={props.value == -1 ? "N/A" : translations[props.value]}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Ignition on */}
        {!!openModal && isHovered ? (
          <IconButton onClick={() => openModal(props, ModalType.DIAGNOSTIC_DETAILS)}>
            <InfoIcon fontSize="small" />
          </IconButton>
        ) : (
          <PowerSettingsNewIcon sx={{ color: bgColor, m: "auto" }} />
        )}
      </Box>
    </Tooltip>
  );
}
